namespace SolovisGateway.Admin.DataEnvironments {

    export class AddDataEnvironmentEditorControl extends Solovis.UI.BaseControl {

        // NOTE: This being public is a legacy of the original javascript code. Could be cleaned up.
        public _formBuilder: Solovis.UI.InputControls.FormBuilder;

        private _environmentPools;
        private _organizations;        

        private _initErrorText;       
               

        constructor(options) {
            super(options);      
        }


        public doInitAsync() {
            var self = this;

            Solovis.Rpc.invoke(
                "~/Admin/DataEnvironmentAdmin/GetAddNewDataEnvironmentDialogInitialState",
                null,
                function (response, success) {
                    if (success) {
                        self._environmentPools = response.result.environmentPools ? response.result.environmentPools : [];
                        self._organizations = response.result.organizations ? response.result.organizations : [];                     
                        self.notifyInitComplete();
                    }
                    else {
                        self._initErrorText = response.error.message;
                        self.notifyInitComplete();
                    }
                });
        }

        
        public doRender() {
            var self = this;
            
            if (this._initErrorText) {
                this.container.text(this._initErrorText);
                return;
            }

            var formDiv = $("<div>").appendTo(this.container);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            // Subdomain
            formBuilder.addEntry({
                name: "subdomain",
                label: "Subdomain",

                initialValue: null,

                editor: {
                    type: "text",
                    textOptions: {
                        maxLength: 255,
                        width: 300
                    },
                    required: true
                }                
            });

            // Description
            formBuilder.addEntry({
                name: "description",
                label: "Description",

                initialValue: null,

                editor: {
                    type: "text",
                    textOptions: {
                        maxLength: 255,
                        width: 300
                    },
                    required: true
                }
            });            

            // Organization
            let organizationOptions = [];
            if (self._organizations.length) {
                $(self._organizations).each(function (i, org: any) {
                    organizationOptions.push({
                        text: org.name,
                        value: org.id
                    });
                });
            }

            formBuilder.addEntry({
                name: "organization",
                label: "Organization (optional)",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: organizationOptions,
                        showClearButton: true,
                        searchEnabled: true
                    }
                },

                isVisible: function (formEntry) {
                    return self._organizations.length > 0;
                }                               
            });

            // Environment Pool
            let environmentPoolOptions = [];
            if (self._environmentPools.length) {
                $(self._environmentPools).each(function (i, envPool: any) {
                    environmentPoolOptions.push({
                        text: envPool.name,
                        value: envPool.id
                    });
                });
            }

            formBuilder.addEntry({
                name: "environmentPool",
                label: "Environment Pool (optional)",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: environmentPoolOptions,
                        showClearButton: true,
                        searchEnabled: true
                    }
                },                

                isVisible: function (formEntry) {
                    return self._environmentPools.length > 0;
                } 
            });           

            formBuilder.setupDone();            

            this._formBuilder = formBuilder;
        }
        

        public setWidth(newWidth) {
            if (this._formBuilder)
                this._formBuilder.setWidth(newWidth);
        }

        public _getAddNewDataEnvironmentModel() {
            let subdomain = this._formBuilder.getValueByName("subdomain");
            let description = this._formBuilder.getValueByName("description");
            let organization = this._formBuilder.getValueByName("organization");
            let environmentPool = this._formBuilder.getValueByName("environmentPool");            

            var model = {
                subdomain: subdomain,
                description: description,
                organizationId: organization,
                environmentPoolId: environmentPool
            };

            return model;
        }

        public hideEditFields() {
            this._formBuilder.showEntries(false);
        }
                       

        public isValid() {
            // Clear top-level errors from any previous save attempts.
            this._formBuilder.formValidationModel.clearState();

            return !this._formBuilder.hasErrors();
        }
    }

}
